@for (row of data; track $index; let last = $last) {
<div class="table-row" [ngClass]="{ bordered: !last }">
  <div class="item clickable" (click)="handleClick(row)">{{ row.effectivePeriod | dateToString }}</div>
  @for (column of displayedColumns; track $index) {
  <div class="item">
    {{ getCellValue(row, column) | minutesToTime }}
  </div>
  }
</div>
} @if (editVisible) {
<app-edit-dialog
  [(visible)]="editVisible"
  [data]="selectedRow"
  (onHistorySave)="onHistorySaveHandler($event)"
  (onRecordRefresh)="onRefreshHistoryHandler($event)"
/>
} @if (monthDetailsVisible) {
<app-month-details [(visible)]="monthDetailsVisible" />
}
